module.exports = __webpack_public_path__ + "img/error-icon.8a97e26b.svg";